<template>
    <div class="container">
        <div class="row align-items-center justify-content-center py-5 my-5">
            <div class="code">{{code}}</div>
            <div class="message" style="padding: 10px;">{{msg}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        code: {
            type: Number,
            default: 404
        },
        msg: {
            type: String,
            default: 'Not Found'
        },

    }
}
</script>

<style lang="css">
.code {
    border-right: 2px solid;
    font-size: 26px;
    padding: 0 15px 0 15px;
    text-align: center;
}

.message {
    font-size: 18px;
    text-align: center;
}
</style>